import { createRouter, ToOptions } from '@tanstack/react-router';

import { trpcQueryUtils } from './trpc';

// Import the generated route tree
import { routeTree } from '@web/routeTree.gen';

// Set up a Router instance
export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  context: {
    trpcQueryUtils,

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    auth: undefined!,
  },
});

declare module '@tanstack/react-router' {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Register {
    router: typeof router;
  }
}

export type HRef = ToOptions['to'];
